import { API } from './api';

export const SUPPORT_HELP_LINK = `${API.dashboard}/help`;
export const EMPTY_ARRAY: readonly [] = [];
export const EMPTY_OBJECT: Readonly<Record<string, never>> = {};
